import { fetchWithErrorHandling } from "./_base";
import type { Language } from "../types/Language";

export const authUserByIdAndPassword = async (
    id: string,
    password: string,
    state: string | null,
    apiUrl: string,
    language: Language,
) => {
    const data = {id: id, password: password, state: state ?? ''};

    return await fetchWithErrorHandling<LoginProcessResponse>(`${apiUrl}/auth/login-process`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'User-Agent': 'web',
        },
        body: JSON.stringify(data),
    }, language);
};
